import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsAwardMocks: MicroMoments = {
  id: 'award-travel',
  title: 'Award Travel Just Got More Rewarding',
  description:
    'Use your miles to <a href="https://www.delta.com/flight-search/book-a-flight" >book your next trip</a> and earn up to 75% more MQMs, MQSs and MQDs before December 31, 2023 with the 2022 Medallion® Status Accelerators.',
  action: {
    label: 'Book Wth Miles',
    url: 'https://www.delta.com/flight-search/book-a-flight'
  },
  actionId: 'award-travel-link',
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/award-travel.svg',
    alt: 'Award Travel Logo image'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
